<script>
import {Line, mixins} from 'vue-chartjs'
const {reactiveProp} = mixins
export default {
    name: 'chartjs-line',
    extends: Line,
    mixins: [reactiveProp],
    props: {
        chartData: {
            type: Object,
            default: () => {
                return {}
            }
        },
        chartOptions: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    mounted () {
      this.addPlugin({
        id: 'fiifi-legend-adjust',
        beforeRender: function(chart) {
          // console.log(util.inspect(chart))
          if (chart.legend.position == 'left' || chart.legend.position == 'right') {
            let legendHeight = (_.reduce(chart.legend.legendHitBoxes, (sum,hb) => {
              return sum + hb.height||0
            }, 0));
            legendHeight = legendHeight||1;
            let spacing = chart.legend.options.labels.padding||1;
            legendHeight += (spacing * (chart.legend.legendHitBoxes.length||1 - 1))
            let chartHeight = chart.height;
            let pad = ((chartHeight / 2) - (legendHeight / 2))
            chart.legend.top = pad;
          }
          // move the chart itself?
          // have not found any options that will move the position of the chart model
          return true
        }
      })
        this.renderChart(this.chartData, this.chartOptions)
    },
    updated () {
        this.renderChart(this.chartData, this.chartOptions)
    }
}
</script>